"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CalculatorSelectableBox = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/CalculatorSelectableBox"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _SelectionButtonWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/calculator/SelectionButtonWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _HubEditionToIconMap = _interopRequireDefault(require("../../constants/HubEditionToIconMap"));

var CurrentPlanText = _styledComponents.default.span.withConfig({
  displayName: "EditionSelectionButton__CurrentPlanText",
  componentId: "sc-150gtqg-0"
})(["font-weight:600;"]);

var StyledFormattedMessage = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "EditionSelectionButton__StyledFormattedMessage",
  componentId: "sc-150gtqg-1"
})(["&&&{font-size:13px;}"]);
var ButtonContents = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "EditionSelectionButton__ButtonContents",
  componentId: "sc-150gtqg-2"
})(["height:36px;line-height:18px;"]);

var EditionSelectionButton = function EditionSelectionButton(_ref) {
  var selected = _ref.selected,
      edition = _ref.edition,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      currentPlan = _ref.currentPlan,
      hub = _ref.hub;
  var hasIcon = hub && edition && _HubEditionToIconMap.default[hub][edition];
  return _react.default.createElement(_SelectionButtonWrapper.default, null, _react.default.createElement(_CalculatorSelectableBox.default, {
    onClick: (0, _partial.default)(onClick, edition),
    selected: selected,
    disabled: disabled,
    "data-selenium-id": edition + "-edition-button"
  }, _react.default.createElement(ButtonContents, {
    direction: "column",
    align: "center",
    justify: "center"
  }, _react.default.createElement(_UIFlex.default, {
    align: "center"
  }, hasIcon && _react.default.createElement(_UIImage.default, {
    src: _HubEditionToIconMap.default[hub][edition],
    className: "m-right-1"
  }), _react.default.createElement(StyledFormattedMessage, {
    className: "plan-selector-button-text",
    message: "pricingPage.calculator.edition." + edition
  })), currentPlan && _react.default.createElement(CurrentPlanText, null, _react.default.createElement(StyledFormattedMessage, {
    message: "pricingPage.highlightedMerchCards.currentPlanParentheses"
  })))));
};

EditionSelectionButton.propTypes = {
  hub: _propTypes.default.string,
  edition: _propTypes.default.string.isRequired,
  selected: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func,
  currentPlan: _propTypes.default.bool
};
EditionSelectionButton.defaultProps = {
  currentPlan: false
};
var _default = EditionSelectionButton;
exports.default = _default;
module.exports = exports.default;